'use client';

import { Section } from '@/components/ui/layouts/sections/Section';
import { useEffect } from 'react';

export const FormBlock = ({ data }) => {
  useEffect(() => {
    const widgetScriptSrc = 'https://tally.so/widgets/embed.js';

    const loadTally = () => {
      if (window.Tally) {
        window.Tally.loadEmbeds();
      } else if (!document.querySelector(`script[src="${widgetScriptSrc}"]`)) {
        const script = document.createElement('script');
        script.src = widgetScriptSrc;
        script.onload = () => window.Tally?.loadEmbeds();
        document.body.appendChild(script);
      }
    };

    loadTally();
  }, []);

  return (
    <Section
      heading={{
        title: data?.fields?.title,
        epi: data?.fields?.epi,
      }}
    >
      <iframe
        data-tally-src={data?.fields?.url}
        loading='lazy'
        width='100%'
        height='500'
        frameBorder={0}
        marginHeight={0}
        marginWidth={0}
        title={data?.fields?.title}
      />
    </Section>
  );
};
